import { FC } from "react";
import {
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { Entity } from "@common/types/entity";
import { ConnectPlaid } from "@components/plaid/ConnectPlaid/ConnectPlaid";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { Button } from "@design-system/Button/Button";
import { RELAY_PREVIEW_URL, RELAY_URL } from "@constants";
import { PLAID_INSTITUTIONS_NAMES } from "@common/constants";
import styles from "./RelayModal.module.scss";

interface Props {
    defaultEntity: Entity | undefined;
}

export const RelayModal: FC<Props> = ({ defaultEntity }) => {
    const handleSignup = () => {
        window.open(RELAY_URL, "_blank", "noopener noreferrer");
    };

    return (
        <>
            <StandardModalHeader>
                <h4 className={styles.heading}>Connect your Relay account</h4>
            </StandardModalHeader>

            <StandardModalBody>
                <main>
                    <p className={styles.lead}>
                        Kick recommends Relay, the highest-rated online banking
                        platform on Trustpilot, used by 150,000 US business
                        owners.
                    </p>

                    <img
                        src={RELAY_PREVIEW_URL}
                        alt="Relay account"
                        className={styles.preview}
                    />

                    <footer className={styles.footer}>
                        <ConnectPlaid
                            institutionName={PLAID_INSTITUTIONS_NAMES.RELAY}
                            defaultEntity={defaultEntity}
                        >
                            {({ connecting, initializeConnection }) => (
                                <ButtonWithLoader
                                    variant="primary"
                                    size="md"
                                    loading={connecting}
                                    onClick={initializeConnection}
                                >
                                    Connect existing account
                                </ButtonWithLoader>
                            )}
                        </ConnectPlaid>
                        <Button
                            variant="primary"
                            size="md"
                            onClick={handleSignup}
                        >
                            Sign up for Relay
                        </Button>
                    </footer>
                </main>
            </StandardModalBody>
        </>
    );
};
